module.exports = __webpack_public_path__ + "img/twitter.24058c29.svg";